<template>
  <div class="header">
    <div class="wp-header">
      <a href="/" class="logo" title="迅雷"></a>
      <Input />
      <ul class="header-nav">
        <li v-for="(item, i) in tabs" :key="i">
          <a
            v-if="item.target"
            :href="item.path"
            target="_blank"
            @click="
              $util.clickStat(
                `GWSY/TAG${item.name}`,
                `官网首页/标签栏${item.title}`
              )
            "
          >
            {{ item.title }}
          </a>
          <a
            v-else
            href="javascript:;"
            :class="{ cur: checkPath(item.path) }"
            @click="
              jump(item, i)
              $util.clickStat(
                `GWSY/TAG${item.name}`,
                `官网首页/标签栏${item.title}`
              )
            "
          >
            {{ item.title }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Input from '~/components/common/Input3'
export default {
  components: {
    Input
  },
  data() {
    return {
      tabs: [
        { title: '首页', path: '/', name: 'SY' },
        { title: '全部游戏', path: '/all-game', name: 'QBYX' },
        { title: '账号充值', path: '/recharge', name: 'ZHCZ' },
        { title: '礼包中心', path: '/gifts', name: 'LBZX' },
        { title: '个人中心', path: '/personal', name: 'GRZX' },
        { title: '客服中心', path: '/customer', name: 'KFZX' },
        { title: '贵族特权', path: '/vip-rights', name: 'GZTQ', target: true }
      ]
    }
  },
  computed: {
    curPath() {
      return this.$store.state.route.path
    }
  },
  watch: {
    curPath: {
      handler(_new, old) {
        if (old.includes('/all-game')) {
          this.$store.commit('allGame/setSearchName', '')
        }
      }
    }
  },
  methods: {
    checkPath(path) {
      if (path === this.curPath) return true
      return path !== '/' && this.curPath.includes(path)
    },
    jump({ path }, index) {
      this.$router.push(path)
      this.tabs.forEach((e) => (e.cur = false))
      this.tabs[index].cur = true
    }
  }
}
</script>
